<template>
        <div class="sm:p-6 mt-4 md:mt-0 h-screen bg-gray-900">
            <span class="transition duration-500 ease-in-out flex w-full rounded-md">
                <span scope="col" class="w-1/3 flex justify-center px-6 py-3 text-center text-xs font-medium text-white">
                    <img :src="asset('images/racingleague/powered-by-rs.png')" class="w-2/4 h-fit" />
                </span>

                <span scope="col" class="w-1/3 flex flex-col justify-center px-6 py-3 text-center text-xs font-medium text-white">
                    <img :src="asset('images/racingleague/racingleague-live.png')" class="w-3/4 mx-auto" />
                </span>
                <span scope="col" class="w-1/3 flex justify-center px-6 py-3 text-center text-xs font-medium text-white">
                    <img :src="asset('images/racingleague/play-store.png')" class="w-2/4 h-fit" />
                    <!-- <p class="text-2xl w-fit">{{ teamStandings.latest_race }}</p> -->
                </span>
            </span>

            <div v-if="processing" class="flex justify-center">
                <span class="text-gray-900 bg-racing-stars-yellow font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 inline-flex items-center">
                    <svg role="status" class="inline mr-3 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#000001"/>
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"/>
                    </svg>
                    Loading...
                </span>
            </div>
            <div v-else>
                <!-- <carousel v-if="Object.keys(leaderboards).length > 0" :wrap-around="true" :autoplay="6000"> -->
                <carousel v-if="Object.keys(leaderboards).length > 0 || true" :wrap-around="true" :autoplay="14000">
                    <slide v-for="slide in 3" :key="slide">

                        <!-- Teams Standings -->
                        <span v-if="slide === 1" class="sm:py-4 gap-8 h-full w-screen">
                            <Leaderboard :leaderboard="teamStandings" :type="'team'" :index="index" :icon="'FlagIcon'" :title="'LATEST TEAMS RANKING'"/>
                        </span>

                        <!-- Jockey Standings -->
                        <span v-if="slide === 2" class="sm:py-4 gap-8 h-full w-screen">
                            <Leaderboard :leaderboard="jockeyStandings" :type="'jockey'" :index="index" :icon="'FlagIcon'" :title="'LATEST JOCKEY RANKING'"/>
                        </span>

                        <!-- Meeting and Global Standings -->
                        <span v-if="slide === 3" class="sm:py-4 grid grid-cols-2 gap-8 h-full w-screen">
                            <Leaderboard v-for="leaderboard in leaderboards" :type="'local'" :leaderboard="leaderboard" :index="index" :icon="'LocationMarkerIcon'" :title="(leaderboard.name + ' LEAGUE STANDINGS')" />
                            <Leaderboard :leaderboard="league[0]" :type="'global'" :index="index" :icon="'GlobeIcon'" :title="'GLOBAL LEAGUE RANKING'"/>
                        </span>


                    </slide>
                    
                </carousel>

                <div v-else>
                    <tw-card :showTitle="true" :hideHow="true" class="my-4 transition duration-500 ease-in-out dark:text-white h-auto dark:bg-gray-900 p-2">
                        The leaderboards will be available when a race starts. Please come back later.
                    </tw-card>
                </div>
            </div>
        </div>
</template>
<script>

import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'
import Leaderboard from './Partials/Leaderboard.vue';
import AppLayout from '@/Layouts/Layout.vue'
import JetSelect from '@/Jetstream/Select.vue'
import JetDatePicker from '@/Jetstream/DatePicker.vue'
import moment from 'moment'
// import Pagination from '@/Global/Pagination'
import {Disclosure, DisclosureButton, DisclosurePanel} from "@headlessui/vue";
import { ChevronDownIcon, ClockIcon, DatabaseIcon, UsersIcon, CheckIcon, StarIcon, FireIcon, GlobeAltIcon } from '@heroicons/vue/outline'
import {computed, onMounted, ref, watch} from "vue";

export default {
    props: {
        scores: Object,
        leaderboardSelf: Object,
        user: Object,
    },
    components: {
        AppLayout,
        JetSelect,
        JetDatePicker,
        Pagination,
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        ChevronDownIcon,
        ClockIcon,
        DatabaseIcon,
        UsersIcon,
        CheckIcon,
        StarIcon,
        FireIcon,
        GlobeAltIcon,
        Leaderboard,
        Carousel,
        Slide,
        Pagination,
        Navigation,
    },

    data() {
        return {
            tab: 1,
        };
    },
    methods: {
        activeTabOne(meetingid) {
            this.tab = meetingid+1;
        },
        activeTabTwo(meetingid) {
            this.tab = meetingid+2;
        },
    },
    setup(props) {
        const leaderboards = ref([])
        const raceStandings = ref([])
        const jockeyStandings = ref([])
        const teamStandings = ref([])
        const league = ref([])
        const processing = ref(true)
        const scores = ref(true)

        const dateModel = ref(new Date().toLocaleDateString('en-GB'))

        const format = ref({
            date: 'DD/MM/YYYY',
            month: 'MMM'
        })

        const getLeaderboards = () => {
            const pathSegments = window.location.pathname.split('/');
            const lastSegment = pathSegments[pathSegments.length - 1];

            processing.value = true
            axios.get(route('api.leaderboard.get'), {
                params: {
                    meeting: lastSegment
                }
                }).then(response => {
                    leaderboards.value = response.data
                    processing.value = false
                })

            axios.get(route('api.leaderboard.getRaceLeaderboard'), {
                params: {
                    meeting: lastSegment
                }
                }).then(response => {
                    raceStandings.value = response?.data[0]?.races[0]
                    processing.value = false
                })

            axios.get(route('api.leaderboard.getJokeyLeaderboard'), {
                params: {
                    meeting: lastSegment
                }
                }).then(response => {
                    jockeyStandings.value = response.data
                    processing.value = false

                    console.log("jockey : ", jockeyStandings)
                })

            axios.get(route('api.leaderboard.getTeamsLeaderboard'), {
                params: {
                    meeting: lastSegment
                }
                }).then(response => {
                    teamStandings.value = response.data
                    processing.value = false

                    console.log("teams : ", teamStandings)
                })
        }

        const getScores = () => {
            axios.get(route('api.scores.index'), {
                params: {
                    date: dateModel.value,
                }
            }).then(response => {
                scores.value = response.data
            })
        }

        const getLeague = () => { 
            axios.post(route("api.getLeagueLeaderboardLifetime.get", { code: 'racingleague' }))
                .then((response) => {
                    const sortedValues = Object.values(response.data).sort((a, b) => b.lifetime_points - a.lifetime_points);
                    league.value = sortedValues;
                });
        }

        const highlightUser = (result) => {
            let color = 'bg-gray-800'

            if (result === props.user.id) {
                color = 'bg-gray-500'
            }

            return color
        }
        const log = (logger) => {
            return console.log(logger)
        }

        const getNumberWithOrdinal = (n) => {
            var s = ['th', 'st', 'nd', 'rd'],
                v = n % 100;

            return n + (s[(v - 20) % 10] || s[v] || s);
        }

        const dDate = computed(() => {
            let splitDate = dateModel.value.split('/');
            let month = splitDate[1] - 1;
            let modelDate = new Date(splitDate[2], month, splitDate[0])

            return modelDate > new Date()

        })

        onMounted(() => {
            getLeaderboards()
            getLeague()
            getScores()
        })

        return {
            leaderboards,
            jockeyStandings,
            raceStandings,
            teamStandings,
            moment,
            getLeaderboards,
            getNumberWithOrdinal,
            highlightUser,
            log,
            dateModel,
            format,
            dDate,
            league,
        }
    }




}

</script>
